// removed by extract-text-webpack-plugin
module.exports = {"Button":"ButtonIconConfirm__Button__2INxX","Success":"ButtonIconConfirm__Success__NSdQd","Danger":"ButtonIconConfirm__Danger__3hyuh","Neutral":"ButtonIconConfirm__Neutral__JvOlR","Small":"ButtonIconConfirm__Small__2q5H9","ButtonText":"ButtonIconConfirm__ButtonText__2Zaae"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ButtonIconConfirm/ButtonIconConfirm.css
// module id = 336
// module chunks = 0